import { format } from '../string';

const formatPrice = (value: string | undefined) => format(value, 'price', { invalidValue: false });

export type DiscountValueTextParams = {
    discountType?: 'percent' | 'fixed_amount';
    discountValue?: string;
    minimumOrderAmount?: string | null;
    isShort?: boolean;
};

export const formatDiscountValue = (discountType?: 'percent' | 'fixed_amount', discountValue?: string) =>
    discountType === 'percent' ? `${discountValue}%` : formatPrice(discountValue);

export const getDiscountValueText = ({
    discountType,
    discountValue,
    minimumOrderAmount,
    isShort = false,
}: DiscountValueTextParams): string => {
    const prefix = isShort ? '' : 'Скидка ';
    const formattedDiscountValue = formatDiscountValue(discountType, discountValue);

    if (discountType === 'fixed_amount') {
        if (!minimumOrderAmount) {
            return `${prefix}${formattedDiscountValue}`;
        }

        return `${prefix}${formattedDiscountValue}, при покупке от ${format(minimumOrderAmount, 'price', { invalidValue: 'значение_неизвестно' })}`;
    }

    if (discountType === 'percent') {
        return `${prefix}${formattedDiscountValue}`;
    }

    return 'Скидка неизвестна';
};
